<template>
  <b-card
    title="مدیریت لیست های غذایی"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
        <b-row>
          <div class="filter-row">
            <b-button
                class="mb-1 mr-auto ml-1"
              variant="primary"
              :to="{name:'addDedicatedFoodList'}"
            >
              جدید
            </b-button>
          <b-col md="auto">
            <b-form-group
              label="عنوان"
              label-for="Title"
            >
              <b-form-input
                v-model="filterOptions.Title"
                @keyup.enter="update(1)"
              />
            </b-form-group>
          </b-col>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              class="mb-1 mr-1"
              variant="warning"
              @click="update(1)"
            >فیلتر
            </b-button>
          </div>
        </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'addDedicatedFoodList', params: { listFoodId: data.value }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>
          <template #cell(actions)="data">
            <div
              class="text-nowrap"
            >
              <b-link :to="{name:'addDedicatedFoodList',params:{listFoodId:data.item.Id}}">
                <feather-icon
                  icon="EditIcon"
                  size="16"
                />
              </b-link>
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1"
                @click="remove(data.item.Id)"
              />
              <b-link :to="{name:'addDedicatedFoodList',params:{listFoodId:data.item.Id , clone:'clone'}}">
                <feather-icon
                    icon="CopyIcon"
                    class="ml-1"
                    size="16"
                />
              </b-link>
            </div>
          </template>
          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>
  </b-card>

</template>

<script>
export default {
  name: 'SpecialDietFoodList',
  data() {
    return {
      loading: false,
      filterOptions: {
        Page: 1,
        Title: '',
        PerPage: 10,
      },
      totalRows: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })
      this.$http.post(this.$api.dedicatedfoodList.getlist, this.filterOptions).then(res => {
        this.items = res.data
        this.totalRows = res.totalRow
      }).finally(() => {
        this.loading = false
      })
    },
    save() {
      let url
      if (this.editCalorie) url = this.$api.dedicatedfoodList.update
      else url = this.$api.dedicatedfoodList.add
      this.$http.post(url, this.form).then(() => this.update())
    },
    remove(id) {
      this.removeRow(this.$api.dedicatedfoodList.remove, 'Id', id)
    },
  },
}
</script>

<style scoped>

</style>
